import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux"
import Select from 'react-select';
import DatePicker from "react-datepicker";
import { min, max } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import InputMask from 'react-input-mask';
import moment from 'moment';

const FilterСhecklist = ({data, fields, setValue, items, setItems}) => {
  const inputRefDate = useRef(null)
  const auth = useSelector(state => state.auth);
  const [formFields, setFields] = useState({ ...fields })

  useEffect(()=>{
    if(data) filtrate();
  },[fields]) 

  const filtrate = () => {

      const filteredData = data.filter(
        (el) => {
          return (
            //(!fields.date.value || new Date(el.dateCheck).toISOString().split('T')[0] === new Date(fields.date.value.setHours(12,0,0,0)).toISOString().split('T')[0]) &&
            (!fields.date.value || el.dateCheck.split(" ")[0] === moment(fields.date.value).format('DD.MM.YYYY')) &&
            (!fields.phone.value || el.phone.includes(fields.phone.value.replace(/[^0-9]/g, ''))) &&
            (!fields.result.value || el.result === fields.result.value.value) &&
            (!fields.brocker.value || el.brocker === fields.brocker.value.value) &&
            (!fields.search.value || Object.values(el).filter((item) => typeof item == "string" && item.toLowerCase().indexOf(fields.search.value.toLowerCase()) > -1).length) 
          )
        }
      );
      
      setItems(filteredData);
  };

  const changeValue = (name, value) => {
      setValue({ ...fields, [name]: { ...fields[name], value } })
  }
    
  const clearFilter = () => {
      setValue({ ...formFields })
  };
    
  const onClickOutside = () => {
    inputRefDate.current.cancelFocusInput();
    inputRefDate.current.setOpen(false)
  };

  return (
    <div className="filter-block">
      <div>
        <div className="filter-block__column">
          <div className="filter-block__row">
            <div>
              <DatePicker  
                ref={inputRefDate}                      
                showIcon
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none" onClick={() => inputRefDate.current.setOpen(true)}>
                    <path d="M13.75 1.5V4.76316M5.25 1.5V4.76316M1 8.02632H18M1 4.76316C1 4.20481 1.22388 3.66933 1.6224 3.27451C2.02091 2.8797 2.56141 2.65789 3.125 2.65789H15.875C16.4386 2.65789 16.9791 2.8797 17.3776 3.27451C17.7761 3.66933 18 4.20481 18 4.76316V17.3947C18 17.9531 17.7761 18.4886 17.3776 18.8834C16.9791 19.2782 16.4386 19.5 15.875 19.5H3.125C2.56141 19.5 2.02091 19.2782 1.6224 18.8834C1.22388 18.4886 1 17.9531 1 17.3947V4.76316Z" stroke="#2D2D2C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.59379 11.4C5.59379 11.6387 5.49322 11.8676 5.31419 12.0364C5.13517 12.2052 4.89236 12.3 4.63918 12.3C4.386 12.3 4.14319 12.2052 3.96417 12.0364C3.78515 11.8676 3.68457 11.6387 3.68457 11.4C3.68457 11.1613 3.78515 10.9324 3.96417 10.7636C4.14319 10.5948 4.386 10.5 4.63918 10.5C4.89236 10.5 5.13517 10.5948 5.31419 10.7636C5.49322 10.9324 5.59379 11.1613 5.59379 11.4ZM5.59379 15.9C5.59379 16.1387 5.49322 16.3676 5.31419 16.5364C5.13517 16.7052 4.89236 16.8 4.63918 16.8C4.386 16.8 4.14319 16.7052 3.96417 16.5364C3.78515 16.3676 3.68457 16.1387 3.68457 15.9C3.68457 15.6613 3.78515 15.4324 3.96417 15.2636C4.14319 15.0948 4.386 15 4.63918 15C4.89236 15 5.13517 15.0948 5.31419 15.2636C5.49322 15.4324 5.59379 15.6613 5.59379 15.9ZM10.455 11.4C10.455 11.6387 10.3544 11.8676 10.1754 12.0364C9.99635 12.2052 9.75354 12.3 9.50036 12.3C9.24718 12.3 9.00437 12.2052 8.82535 12.0364C8.64632 11.8676 8.54575 11.6387 8.54575 11.4C8.54575 11.1613 8.64632 10.9324 8.82535 10.7636C9.00437 10.5948 9.24718 10.5 9.50036 10.5C9.75354 10.5 9.99635 10.5948 10.1754 10.7636C10.3544 10.9324 10.455 11.1613 10.455 11.4ZM10.455 15.9C10.455 16.1387 10.3544 16.3676 10.1754 16.5364C9.99635 16.7052 9.75354 16.8 9.50036 16.8C9.24718 16.8 9.00437 16.7052 8.82535 16.5364C8.64632 16.3676 8.54575 16.1387 8.54575 15.9C8.54575 15.6613 8.64632 15.4324 8.82535 15.2636C9.00437 15.0948 9.24718 15 9.50036 15C9.75354 15 9.99635 15.0948 10.1754 15.2636C10.3544 15.4324 10.455 15.6613 10.455 15.9ZM15.3161 11.4C15.3161 11.6387 15.2156 11.8676 15.0366 12.0364C14.8575 12.2052 14.6147 12.3 14.3615 12.3C14.1084 12.3 13.8655 12.2052 13.6865 12.0364C13.5075 11.8676 13.4069 11.6387 13.4069 11.4C13.4069 11.1613 13.5075 10.9324 13.6865 10.7636C13.8655 10.5948 14.1084 10.5 14.3615 10.5C14.6147 10.5 14.8575 10.5948 15.0366 10.7636C15.2156 10.9324 15.3161 11.1613 15.3161 11.4ZM15.3161 15.9C15.3161 16.1387 15.2156 16.3676 15.0366 16.5364C14.8575 16.7052 14.6147 16.8 14.3615 16.8C14.1084 16.8 13.8655 16.7052 13.6865 16.5364C13.5075 16.3676 13.4069 16.1387 13.4069 15.9C13.4069 15.6613 13.5075 15.4324 13.6865 15.2636C13.8655 15.0948 14.1084 15 14.3615 15C14.6147 15 14.8575 15.0948 15.0366 15.2636C15.2156 15.4324 15.3161 15.6613 15.3161 15.9Z" fill="#2D2D2C"/>
                  </svg>
                }
                showPopperArrow={false}
                className="form__input"
                placeholderText={'Дата проверки'}
                selected={fields.date.value}  
                onChange={(val) => changeValue('date', val)}    
                disabledKeyboardNavigation               
                locale="ru"      
                minDate={data && min(data.map((i) => new Date(i.dateCheck.split(" ")[0].split(".").reverse().join("-"))))}
                maxDate={data && max(data.map((i) => new Date(i.dateCheck.split(" ")[0].split(".").reverse().join("-"))))}
                dateFormat="dd.MM.yyyy"
              />
            </div>
            <div>
              <InputMask
                value={fields.phone.value}  
                mask='+7 999 999 99 99'
                maskChar={null}
                type="tel"                      
                replacement={{ _: /\d/ }}
                className="form__input"
                placeholder={'Номер телефона'}
                onChange={(e) => changeValue('phone', e.target.value)}  
                autoComplete="off"
              />
            </div>
          </div>
          {auth.user.group == 'lead' && (
            <Select
              className="select"
              classNamePrefix="select"
              placeholder={'Брокер'}         
              value={fields.brocker.value}  
              isSearchable={false}        
              components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
              }}
              onFocus={onClickOutside}
              defaultValue={null}
              onChange={(val) => changeValue('brocker', val)}  
              options={data ? data.map((item) => ({value: item.brocker, label: item.brocker})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
            />
          )}
        </div>
        <div className="filter-block__column">
          <div className={auth.user.group == 'lead' ? "filter-block__row filter-block__row_column" : "filter-block__row"}>
            <div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Результат'}    
                value={fields.result.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                onFocus={onClickOutside}
                defaultValue={null}
                onChange={(val) => changeValue('result', val)}  
                options={data ? data.map((item) => ({value: item.result, label: item.result ? 'УНИКАЛЬНЫЙ' : 'НЕ УНИКАЛЬНЫЙ'})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              /> 
            </div>
            <div>
              <div className="form__search">
                <input
                  value={fields.search.value}  
                  type="text"
                  className="form__input"
                  placeholder={'Поиск по таблице'}
                  onChange={(e) => changeValue('search', e.target.value)}  
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button type="button" className="btn btn_empty btn_small" onClick={clearFilter}>Очистить фильтр</button>
      </div>
    </div>
  )

}

export default FilterСhecklist